<script>
import InvoicesApi from "@/services/invoices-api";
import CustomersApi from "@/services/customers-api";
import GlobalSettingApi from "@/services/global-settings-api";
import MailInvoiceSettingCard from "@/components/MailInvoiceSettingCard.vue";
import Swal from "sweetalert2";

export default {

  components: {
    MailInvoiceSettingCard,
  },

  data() {
    return {
      invoicesList: [],
      isTableLoading: true,
      pagemodel: { currentPage: 1, perPage: 5, totalRows: 0 },
      openSections: {},
      openMails: {},
      customersList:[],
      selectedCustomer:null,
      start:this.firstDay,
      end:this.lastDay,
      selectedCompanyType: null,
      selectedMailStatus: null,

      downloadFields: [
        { key: "invoiceType", label: "Type de facture" },
        { key: "userAgent", label: "Agent utilisateur" },
        { key: "ipAddress", label: "Adresse IP" },
        { key: "timestamp", label: "Horodatage" }
      ],

      options: [
        { value: 1, label: "reporting.supplier.tabMailInvoice.btnReleve", key: "fact" },
        { value: 2, label: process.env.VUE_APP_CLIENT_NAME === "cab" ? "reporting.supplier.tabMailInvoice.btnElectronicCab" : "reporting.supplier.tabMailInvoice.btnElectronic", key: "fe" },
        { value: 3, label: "reporting.supplier.tabMailInvoice.btnTnn", key: "fttn" }
      ],

      invoiceMailSettings: [],
      mailBodyHTML: null,
      showMailBodyHTML: false,
      resendAllMailInProgress: false,
      manualMailInvoiceSettingCard: false,
      selectedInvoice: null,

      companyTypeOptions: [
        { value: "PARA",   label: "Para-Pharmaceutique" },
        { value: "PHARMA", label: "Pharmaceutique" }
      ],

      mailStatusOptions: [
        { value: "0",   label: "En cours" },
        { value: "1", label: "Envoyés" },
        { value: "2", label: "Non Envoyés" }
      ]
    };
  },
  mounted() {
    this.loadInvoices();
    this.getInvoiceSettings();
    this.getCustomers()

  },
  computed: {
    mailStatusMap() {
      return {
        0: "Nouveau",
        1: "Envoyé",
        2: "Erreur"
      };
    }
  },
  methods: {

    openMailManualSettingModal(invoice){
      this.selectedInvoice = null
      if(invoice){
        this.selectedInvoice = invoice
      }
      this.manualMailInvoiceSettingCard = true
    },

    resendMail(selectedList){
      if(this.selectedInvoice){
        this.resendManualInvoice(this.selectedInvoice.id, this.selectedInvoice.number, selectedList)
        this.selectedInvoice = null
        this.manualMailInvoiceSettingCard = false
      }else{
        this.resendMailInvoices(selectedList);
        this.manualMailInvoiceSettingCard = false
      }
    },

    getInvoiceSettings() {
      GlobalSettingApi.getInvoiceSettings().then(response => {
        this.invoiceMailSettings = response;
      });
    },

    saveInvoiceSettings(selectedList) {
      GlobalSettingApi.saveInvoiceSettings(selectedList).then(response => {
        this.invoiceMailSettings = response;
      });
    },

      toggleCollapse(index) {
        if (window.innerWidth >= 576) {
        this.$root.$emit('bv::toggle::collapse', 'invoice-' + index)
        }
    },
    

    getCustomers(){
        CustomersApi.getCustomers(null,null).then(
            response => {
            this.customersList=response;
            }
        )
    },

    resendManualInvoice(invoiceId, invoiceNumber, selectedList){
        this.isTableLoading = true;
        InvoicesApi.resendInvoice(invoiceId, invoiceNumber, this.pagemodel.currentPage, this.pagemodel.perPage,
        this.selectedCustomer == null ? null : this.selectedCustomer.id, this.start,  this.end, selectedList,
        this.selectedCompanyType ? this.selectedCompanyType.value : null, this.selectedMailStatus ? this.selectedMailStatus.value : null)
        .then((result) => {
            if (result) {
            this.invoicesList = result.list || [];
            this.pagemodel.totalRows = result.total || 0;
            this.openSections = {};
            this.openMails = {};
            }
        })
        .finally(() => {
            this.isTableLoading = false;
        });
    },  
    
    getTypeLabel(type) {
        switch(type) {
        case 'FTTN':
            return this.$t("reporting.supplier.tabMailInvoice.btnTnn");
        case 'FE':
            return this.$t(process.env.VUE_APP_CLIENT_NAME === "cab" ? "reporting.supplier.tabMailInvoice.btnElectronicCab" : "reporting.supplier.tabMailInvoice.btnElectronic");
        case 'FACT':
            return this.$t("reporting.supplier.tabMailInvoice.btnReleve");
        default:
            return type;
        }
    },
    getMailStatus(statusCode) {
      return this.mailStatusMap[statusCode] || "Inconnu";
    },

    loadInvoices() {

      this.invoicesList = [];
      this.isTableLoading = true;
      InvoicesApi.getStatusMailInvoices( this.pagemodel.currentPage, this.pagemodel.perPage,
        this.selectedCustomer == null ? null : this.selectedCustomer.id, this.start,  this.end,
         this.selectedCompanyType ? this.selectedCompanyType.value : null, this.selectedMailStatus ? this.selectedMailStatus.value : null)
      .then((result) => {
        if (result) {
            this.invoicesList = result.list || [];
            this.pagemodel.totalRows = result.total;
            this.pagemodel.currentPage = result.page;
            this.pagemodel.perPage = result.pageSize;
            this.pagemodel.pageSize = result.pageSize;
            this.openSections = {};
            this.openMails = {};
        }
        this.isTableLoading=false
      })
      .finally(() => {
        this.isTableLoading = false;
      });
    },

    resendMailInvoices(selectedList) {

      const customerName = this.selectedCustomer
        ? this.selectedCustomer.name
        : '<span style="text-transform: uppercase;">Tous les clients</span>';

      const startDate = this.start
        ? new Date(this.start).toLocaleDateString('fr-FR')
        : '';

      const endDate = this.end
        ? new Date(this.end).toLocaleDateString('fr-FR')
        : '';

      const invoiceCount = this.pagemodel.totalRows;
      this.resendAllMailInProgress = true;
      const companyNotSent = this.getCompanyNotSent(selectedList);

      Swal.fire({
        title: 'Confirmation',
        html: `
          <p>
            Voulez-vous vraiment ré-envoyer <strong>${invoiceCount}</strong> facture(s)
            à <strong>${customerName}</strong> ?
          </p>

          ${
            companyNotSent
              ? `
                <p>
                  <small style="color: #d32f2f;">
                    Les factures de type <strong style="text-transform: uppercase;">${companyNotSent}</strong> ne seront pas envoyées.
                  </small>
                </p>
              `
              : ''
          }

          <p>
            <strong>${startDate ? "Du " + startDate : ""}</strong>
            <strong>${endDate ? " Au " + endDate : ""}</strong>
          </p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, envoyer',
        cancelButtonText: 'Annuler'
      }).then((swalResult) => {

        if (!swalResult.isConfirmed) {
          this.resendAllMailInProgress = false;
          return;
        }

        InvoicesApi.resendMailInvoices(
          this.pagemodel.currentPage,
          this.pagemodel.perPage,
          this.selectedCustomer ? this.selectedCustomer.id : null,
          this.start,
          this.end,
          selectedList,
          this.selectedCompanyType ? this.selectedCompanyType.value : null,
           this.selectedMailStatus ? this.selectedMailStatus.value : null
        )
        .then((result) => {

          if (result && !selectedList) {
            this.invoicesList = result.list || [];
            this.pagemodel.totalRows = result.total;
            this.pagemodel.currentPage = result.page;
            this.pagemodel.perPage = result.pageSize;
            this.pagemodel.pageSize = result.pageSize;
            this.openSections = {};
            this.openMails = {};
          }

        })
        .catch((error) => {
          const messageKey =
            error?.response?.data?.message || 'Erreur inconnue';

          Swal.fire({
            title: 'Erreur',
            text: this.$t ? this.$t(messageKey) : messageKey,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        })
        .finally(() => {
          this.isTableLoading = false;
          this.resendAllMailInProgress = false;
        });

      });
    },

    getCompanyNotSent(settings) {
      const grouped = settings.reduce((acc, item) => {
        acc[item.company] = acc[item.company] || [];
        acc[item.company].push(item.value);
        return acc;
      }, {});

      const notSentCompany = Object.keys(grouped).find(
        company => grouped[company].every(v => v === false)
      );

      return notSentCompany || null;
    },


    getBodyMail(mailId){

        this.mailBodyHTML = null
        InvoicesApi.getBodyMail(mailId).then((result) => {
            this.mailBodyHTML = result
            this.showMailBodyHTML = true
        })
    }
  },

  watch: {
     
    selectedCustomer: function(){
        this.loadInvoices();
    },

    selectedCompanyType: function(){
        this.loadInvoices();
    },

    selectedMailStatus: function(){
        this.loadInvoices();
    },

    end: function(){
      this.loadInvoices();
    },
    start: function(){
      this.loadInvoices();
    },
  },

};
</script>



<template>

<div>
  <div class="card  ">
    <div class="card-body p-0">
      <div class="clearfix m-4">
        <div class="row">

            <h4 class="col-8 card-title mb-4 font-size-18 font-weight-bold text-dark">
              {{$t("reporting.supplier.tabMailInvoice.cardTitle")}}
            </h4>

             <div class=" col-4">
                <div class="float-right mb-3">
                    <b-button  title="Sync" size="md"   variant="outline-danger"  @click.prevent="openMailManualSettingModal()" :disabled="resendAllMailInProgress"  >
                        <b-spinner small :class="resendAllMailInProgress ? 'mr-2' : 'd-none'"></b-spinner>
                        <i v-if="!resendAllMailInProgress" class="fas fa-sync-alt  font-size-16  font-weight-bold align-middle  mr-0 mr-sm-2"></i>
                        <span class=" font-weight-bold text-uppercase d-none d-sm-inline">{{$t("reporting.supplier.tabMailInvoice.resendAllMail")}}</span>         
                    </b-button> 
                </div>   
              </div>


          </div>

          <div  class="row mt-2">
              <div class="col-md-3 col-xs-12 pr-md-4 ">
                  <b-form-group :label="$t('lists.customers.filter')" label-for="">
                      <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                      <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                      </v-select>
                  </b-form-group>
              </div>

              <div class="col-md-3 col-xs-12 pr-md-4 ">
                <b-form-group :label="$t('lists.companyTypes.filter')" label-for="">
                    <v-select class="style-vselect-big" style="font-size:1.2em;" :options="companyTypeOptions" :placeholder="$t('lists.companyTypes.label')" label="label" v-model="selectedCompanyType">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
              </div>

              <div class="col-md-3 col-xs-12 pr-md-4 ">
                <b-form-group :label="$t('lists.mailStatuses.filter')" label-for="">
                    <v-select class="style-vselect-big" style="font-size:1.2em;" :options="mailStatusOptions" :placeholder="$t('lists.mailStatuses.label')" label="label" v-model="selectedMailStatus">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
              </div>
              
          </div>

          <div class="row">
              <div class="col-xxl-2 col-md-3 col-xs-12 pr-md-4">
                  <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                      <b-form-datepicker
                      v-model="start"
                      :locale="$t('datPicker.locale')"
                      :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                      dark
                      reset-button
                      close-button
                      :label-reset-button="$t('datPicker.label-reset-button')"
                      :label-close-button="$t('datPicker.label-close-button')"
                      dropright
                      hide-header
                      ></b-form-datepicker>
                  </b-form-group>
              </div>

              <div class="col-xxl-2 col-md-3 col-xs-12 pr-md-4">
                  <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')" label-for="">
                      <b-form-datepicker
                      v-model="end"
                      :locale="$t('datPicker.locale')"
                      :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                      dark
                      reset-button
                      close-button
                      :label-reset-button="$t('datPicker.label-reset-button')"
                      :label-close-button="$t('datPicker.label-close-button')"
                      dropright                         
                      hide-header
                      ></b-form-datepicker>
                  </b-form-group>
              </div>
          </div>


          <div v-if="invoicesList.length">
              <div v-for="(invoice, invIndex) in invoicesList" :key="invoice.id">

                  <div class="d-flex justify-content-between align-items-center mb-3 mt-3 cursor-pointer py-3 px-2"
                      style="border-bottom: 1px solid #ddd; border-radius: 4px; background-color: #f9f9f9;"
                        @click="toggleCollapse(invIndex)"
                      >

                      <div class="flex-grow-1">
                          <div class="row">
                              <div class="col-sm-3 col-12 ">
                                  <div class="font-weight-bold text-dark">
                                      N° {{ invoice.number }}
                                      <span >
                                          <b-badge v-if="invoice.company" href="#" :variant="invoice.company === 'PARA' ? 'primary' : 'success'" class="font-size-12 font-weight-bold">
                                              {{invoice.company}} 
                                          </b-badge>
                                      </span>
                                  </div>
                                    <div class="text-dark mt-1">
                                      <strong>{{invoice.customer}} </strong>
                                  </div>
                                  <div class="text-dark">
                                      <span><strong>Total TTC :</strong> {{ invoice.totalWithTaxes }}</span> |
                                                                      <span>{{ invoice.date }}</span>

                                  </div>
                              </div>

                                <div class="col-md-1 col-0 text-center d-none d-md-block">
                                    <div class="font-weight-bold text-dark ">
                                        E-Mails preparés
                                    </div>
                                    <div :class="invoice.countMails ? 'text-success' : 'text-dark'" class=" font-weight-bold mt-1">
                                        {{ invoice.countMails ? invoice.countMails : 0 }}
                                    </div>
                                </div>

                              <div class="col-md-8 col-sm-9 col-12 mt-sm-0 mt-3 text-center align-items-center justify-content-end ">

                                  <div class="row" style=" justify-content: end;">

                                    <div class="col-2 text-center d-none d-md-block">
                                          <div class="font-weight-bold text-dark">
                                              {{ invoice.mailStatus == 0 ? 'Date prevue' : "Date d'envoi" }}
                                          </div>
                                          <div :class="invoice.minSendDate == null ? 'text-dark' : 'text-success font-weight-bold mt-1'">
                                              {{
                                                   (invoice.mailStatus == 0 ? invoice.minSendDate : invoice.minProcessingDate)
                                              }}
                                          </div>
                                      </div>


                                      <div class="col-2 text-center">
                                          <div class="font-weight-bold text-dark">
                                          E-mail envoyé
                                          </div>
                                          <div class="mt-1">
                                              <img v-if="invoice.mailStatus == 0 " src="@/assets/images/in-progress.svg" class="ml-2" style="width: 25px; height: 25px;" />
                                              <img v-else-if="invoice.mailStatus == 1" src="@/assets/images/check.svg" class="ml-2" style="width: 25px; height: 25px;" />
                                              <img v-else-if="invoice.mailStatus == 2" src="@/assets/images/close.svg" class="ml-2" style="width: 25px; height: 25px;" />
                                              <div v-else>-</div>
                                          </div>
                                      </div>

                                      <div v-for="(downloaded, type) in invoice.downloadInvoiceByType"
                                        :key="type"
                                        class="col-md-2 col-2 text-center d-none d-md-block flex-column justify-content-between"
                                       
                                      >
                                        <div class="font-weight-bold text-dark">
                                          {{ getTypeLabel(type) }}
                                        </div>

                                        <div class="mt-1">
                                          <div v-if="invoice.mailStatus == null">-</div>
                                          <img
                                            v-else-if="downloaded"
                                            src="@/assets/images/check.svg"
                                            class="ml-2"
                                            style="width: 25px; height: 25px;"
                                          />
                                          <img
                                            v-else
                                            src="@/assets/images/close.svg"
                                            class="ml-2"
                                            style="width: 25px; height: 25px;"
                                          />
                                        </div>
                                      </div>


                                    

                                      <div class="col-md-2 col-sm-3 col-6 d-flex align-items-center justify-content-center justify-content-md-end">
                                          <b-button
                                              variant="dark"
                                              size="sm"
                                              class="text-uppercase font-weight-bold mr-3"
                                                  @click="openMailManualSettingModal(invoice)"
                                          >
                                              Ré-envoyer
                                          </b-button>
                                      </div>



                                  </div>

                              </div>



                          </div>
                      
                      </div>

                          <i
                          class="fas fa-chevron-down text-secondary d-none d-sm-block"
                          :class="{ 'rotate-180': openSections[invIndex] }"
                          style="transition: transform 0.3s ease;"
                          ></i>
                  </div>

                  
                  <b-collapse :id="'invoice-' + invIndex" accordion="main-accordion" role="tabpanel"  v-model="openSections[invIndex]" >
                      <div class="timeline-container d-none d-sm-block">

                      <div class="timeline-title">Historique des envois & téléchargements</div>

                      <div v-if="!invoice.mails || !invoice.mails.length" class="timeline-empty text-danger">
                          Aucun mail pour cette facture
                      </div>

                      <div v-else class="timeline">

                          <div v-for="(mail) in invoice.mails" :key="mail.ref" class="timeline-item">
                          <div class="timeline-dot"></div>

                          <div class="timeline-content">

                              <div class="mail-block">
                                  <div class="mail-receiver d-flex justify-content-between align-items-center">


                                      <div v-if="mail.isDownloadedFromWeb" class="d-flex align-items-center">
                                          <img src="@/assets/images/globe.svg" class="mail-icon" />
                                          <span  class="ml-2">
                                            Téléchargé à partir de L'espace client.
                                          </span>
                                      </div>

                                      <div v-else class="d-flex align-items-center">
                                          <img src="@/assets/images/mail.svg" class="mail-icon" />
                                          <span class="ml-2">
                                              {{ mail.processingDate ? "Mail du " + mail.processingDate : "Date prévue d'envoi : " + mail.sendDateAsStr }} <span class="text-dark font-weight-normal ml-2">{{ mail.receiver }}</span> 
                                          </span>
                                      </div>

                                      <span v-if="!mail.isDownloadedFromWeb && invoice.mailStatus == 1" class="mail-action" @click="getBodyMail(mail.id)">
                                          Afficher
                                      </span>


                                  </div>

                                  <div v-if="mail.downloadHistory && mail.downloadHistory.length" class="mail-subinfo text-dark mt-4">
                                      <span >Téléchargements :</span>
                                      <strong> {{ mail.downloadHistory ? mail.downloadHistory.length : 0 }}</strong>
                                  </div>
                              </div>

                              <div v-if="mail.downloadHistory && mail.downloadHistory.length" class="download-list" >
                                  <div class="download-item" v-for="(dl, dlIndex) in mail.downloadHistory" :key="dlIndex" >
                                      <div class="download-dot"></div>

                                      <div class="download-content">
                                      <div class="download-row">
                                          <span class="download-type text-dark text-uppercase"> {{ getTypeLabel( dl.invoiceType) }}</span>
                                          <span class="download-time text-dark">{{ dl.timestamp }}</span>
                                      </div>

                                      <div class="download-meta text-dark">
                                          <div> <span class="font-weight-bold">IP : </span>{{ dl.ipAddress }}</div>
                                          <div><span class="font-weight-bold">User Agent : </span>{{ dl.userAgent }}</div>
                                      </div>
                                      </div>
                                  </div>
                              </div>

                              <div v-else class="no-download text-dark"> Aucun téléchargement </div>

                          </div>
                          </div>

                      </div>

                      </div>
                  </b-collapse>

              </div>
          </div>


          <div v-else class="text-danger d-flex justify-content-center align-items-center"  style="min-height: 20em;" >
            <span v-if="!isTableLoading & !invoicesList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune facture trouvée.</span>
            <div v-else class="spinner-border text-success" role="status">
              <span class=" sr-only">Loading...</span>
            </div>
          </div>

          <!-- Pagination -->
          <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
              <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select 
                  @input="loadInvoices()" 
                  v-model="pagemodel.perPage" 
                  size="sm" 
                  style="width: 5em" 
                  :options="[5, 10,15,50,100]"
                ></b-form-select>

                <div class="d-none d-lg-inline pt-1">
                  <span class="text-dark mb-0 ml-1">De </span>
                  <span class="font-weight-bold"> {{pagemodel.totalRows}} lignes</span>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination 
                    v-model="pagemodel.currentPage" 
                    :per-page="pagemodel.pageSize" 
                    :total-rows="pagemodel.totalRows" 
                    @input="loadInvoices()" 
                    :disabled="isTableLoading"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div> 



          <b-modal
              v-model="showMailBodyHTML"
              centered
              hide-header
              hide-footer
              title-tag="h5"
              header-close-variant="dark"
              title-class="text-primary"
              size="lg"
              body-class="p-4 overflow-auto"
              dialog-class="modal-dialog-scrollable"
          >
              <div v-if="mailBodyHTML && mailBodyHTML.body" class="mail-body" v-html="mailBodyHTML.body"></div>

              <template #modal-footer>
                  <b-button variant="secondary" @click="showMailBodyHTML = false">
                      Annuler
                  </b-button>
              </template>
          </b-modal>
      </div>
    </div>
  </div>


      <div   class="card mt-4">
        <div class="card-body p-0">
          <MailInvoiceSettingCard 
            :invoiceMailSettings.sync="invoiceMailSettings"
            @update:invoiceMailSettings="saveInvoiceSettings" 
          />
        </div>
      </div>

      <b-modal
        v-model="manualMailInvoiceSettingCard"
        centered
        hide-header
        hide-footer
        title-tag="h5"
        header-close-variant="dark"
        title-class="text-primary"
        size="lg"
        @hide="getInvoiceSettings()"
    >
        <MailInvoiceSettingCard 
          :invoiceMailSettings.sync="invoiceMailSettings"
          @update:invoiceMailSettings="saveInvoiceSettings" 
          @resendMail="resendMail"
          :company="selectedInvoice ? selectedInvoice.company : null"
          :isResendMail="true" 
        />

        
    </b-modal>

    </div>
</template>




<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
.cursor-pointer {
  cursor: pointer;
}

.timeline-container {
  padding: 20px 10px;
}

.timeline-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1d1f21;
  margin-bottom: 20px;
}

.timeline-empty {
  font-size: 0.9rem;
  padding: 10px;
  text-align: center;
}

.timeline {
  position: relative;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 2px solid #d5d8dc;
}

.timeline-item {
  margin-bottom: 30px;
  position: relative;
}

.timeline-dot {
  position: absolute;
  left: -12px;
  top: 4px;
  width: 12px;
  height: 12px;
  background: #0069d9;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 0 4px rgba(0,0,0,0.15);
}

.timeline-content {
  background: white;
  border-radius: 6px;
  border: 1px solid #e2e5e9;
  padding: 16px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.06);
}

.mail-block {
  margin-bottom: 12px;
}

.mail-receiver {
  font-weight: 600;
  font-size: 0.95rem;
  color: #222;
}

.mail-date {
  color: #6c757d;
  font-size: 0.85rem;
}

.mail-subinfo {
  font-size: 0.85rem;
}

/* DOWNLOAD ITEMS */
.download-list {
  margin-left: 12px;
  border-left: 2px solid #d5d8dc;
  padding-left: 16px;
  margin-top: 10px;
}

.download-item {
  margin-bottom: 16px;
  position: relative;
}

/* Sub download dot */
.download-dot {
  position: absolute;
  left: -19px;
  top: 6px;
  width: 10px;
  height: 10px;
  background: #17a2b8;
  border-radius: 50%;
  border: 2px solid white;
}

.download-content {
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 5px;
  border: 1px solid #e2e5e9;
}

.download-row {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 6px;
}

.download-type {
  font-size: 0.9rem;
}

.download-time {
  font-size: 0.8rem;
}

.download-meta {
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.no-download {
  font-size: 0.85rem;
  margin-left: 4px;
  padding-top: 2px;
  font-style: italic;
}

.mail-icon {
  width: 18px;
  height: 18px;
  opacity: 0.8;
}

.mail-action {
  color: #007bff;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease;
}

.mail-action:hover {
  color: #0056b3;
}

.mail-body {
  font-size: 0.95rem;
  color: #2b2b2b;
  line-height: 1.6;
}
</style>



<style>
.mail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  margin-bottom: 14px;
}

.mail-label {
  font-weight: 400;
  font-size: 14px;
  color: #2a2f45;
  letter-spacing: 0.3px;
}

.mail-row b-button,
.mail-row .btn {
  border-radius: 5px !important;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.mail-row .btn-outline-primary:hover {
  background-color: rgba(0, 123, 255, 0.12);
  border-color: #007bff;
  color: #007bff;
}


</style>